import {ClientDashboardViewStore} from "app/dashboard/common/store/ClientDashboardViewStore";

export default function() {
    return angular.module("tfApp.dashboard.common", [])
                  .service(ClientDashboardViewStore.id, ClientDashboardViewStore)
                  .name;
}
